import Constants from "@/services/Constants";
import AuthService from "./AuthService";

export default {
	async get() {
		let res = await AuthService.axios().get(`${Constants.adminBackend}/infoblocks/`);
		return res.data;
	},

	async save(item) {
		console.log("saving ", item);
		try {
			let res = await AuthService.axios().put(`${Constants.adminBackend}/infoblocks/`, item);
			return res.data;
		} catch (e) {
			console.log(e);
			alert(`保存失败\n${e}`);
			return {status: "error", message: e}
		}
	},

	async delete(id) {
		console.log("deleting ", id);
		try {
			let res = await AuthService.axios().delete(`${Constants.adminBackend}/infoblocks/${id}`);
			return res.data;
		} catch (e) {
			console.log(e);
			alert(`删除失败\n${e}`);
			return {status: "error", message: e}
		}
	}
}